class PagesManagers {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/pages-managers`;

  }

  async rebuildManagedPages(managerId, data) {

    const path = `${this.basePath}/:managerId/rebuild`;

    return this.apiClient.post(path, { managerId }, {}, data);

  }

  async updatePagesManagerRowsCountById(managerId, data) {

    const path = `${this.basePath}/:managerId/rows-count`;

    return this.apiClient.put(path, { managerId }, {}, data);

  }

  async updatePagesManagerVisibleColumnIdsById(managerId, data) {

    const path = `${this.basePath}/:managerId/visible-columns`;

    return this.apiClient.put(path, { managerId }, {}, data);

  }

  async updatePagesManagerPageBaseSettingsById(managerId, data) {

    const path = `${this.basePath}/:managerId/page-base-settings`;

    return this.apiClient.put(path, { managerId }, {}, data);

  }

  async updatePagesManagerFilterById(managerId, data) {

    const path = `${this.basePath}/:managerId/filter`;

    return this.apiClient.put(path, { managerId }, {}, data);

  }

  async deletePagesManager(managerId) {

    const path = `${this.basePath}/:managerId`;

    return this.apiClient.delete(path, { managerId }, {});

  }

}

export default PagesManagers;